import * as React from 'react';

import { IconCheckmark } from '~shared/components/icons/micro';
import { Link } from '~shared/components/Link';
import { Stack } from '~shared/components/Stack';

interface LinkProps {
  children: React.ReactNode;
  href: string;
}

function FeatureLink({ children, href }: LinkProps) {
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  );
}

export type Feature = {
  text: string;
  /** Link to in-depth support guide article. */
  url?: string;
};

interface Props {
  features: Feature[];
}

/**
 * Display a custom list of feature points, with optional links for each point.
 */
export function PaywallFeatureList({ features }: Props) {
  return (
    <Stack element="ul" space="2">
      {features.map((feature, i) => (
        <div key={i} className="flex items-start justify-start">
          <div className="flex items-center h-8 flex-none pr-2 text-cyan-700">
            <IconCheckmark />
          </div>
          {feature.url ? (
            <FeatureLink href={feature.url}>{feature.text}</FeatureLink>
          ) : (
            <span className="font-500 text-blue-900">{feature.text}</span>
          )}
        </div>
      ))}
    </Stack>
  );
}
